'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'star-half-stroke';
var width = 576;
var height = 512;
var aliases = ["star-half-alt"];
var unicode = 'f5c0';
var svgPathData = 'M297.1 17.1L374.6 164l163.6 28.3 19.1 3.3-13.5 13.9L428 328.5l23.6 164.3 2.8 19.2L437 503.4l-149-73.2-149 73.2L121.7 512l2.8-19.2 23.6-164.3L32.4 209.5 18.9 195.6 38 192.3 201.5 164 279 17.1l9-17.1 9 17.1zm74.7 162.6l-7.8-1.3-3.7-7L296 49.3l0 366.9 138.3 68L412.2 330.8l-1.1-7.8 5.5-5.6L524.6 206.2 371.8 179.7zM280 49.6L215.7 171.4l-3.7 7-7.8 1.3L51.5 206.2 159.6 317.4 165 323l-1.1 7.8L141.9 484.3 280 416.3l0-366.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;